<script setup lang="ts">
import { Heading, ScrollbarTiny, AppButton } from '@pohlcon/design-system';
import { useI18n } from 'vue-i18n';
import Licenses from '../../licenses.txt?raw';
import { useRouter } from 'vue-router';
import packageJson from '../../package.json';

const { t } = useI18n();
const router = useRouter();
</script>

<template>
  <Heading
    :level="1"
    :text="t('legalNotes.licenses')"
  />
  <ScrollbarTiny>
    <span class="content">
      {{ Licenses }}
    </span>
  </ScrollbarTiny>
  <div class="actions">
    Webapp version: {{ packageJson.version }}
    <div class="buttons">
      <AppButton
        @click="router.back()"
        icon='chevron_left'
        :text="t('selectView.back.label')"
        :title="t('selectView.back.title')"
        secondary
      />
      <AppButton
        to="/"
        icon="home"
        :text="t('printView.sidebar.actions.goToHome')"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.scrollbar__container {
  max-height: 63vh;
  overflow: auto;

  .content {
    white-space: pre-line;
  }
}

.actions {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .buttons {
    display: flex;
    justify-content: flex-end;
    gap: var(--gutter-m);

    .btn {
      margin-top: var(--gutter-l);
    }
  }
}
</style>
